// extracted by mini-css-extract-plugin
export default {"conflictListButton":"ConflictListItem_conflictListButton__BDifP"};